import { useState, useRef, useEffect } from 'react'

const MORE_PAGES = ['daily-schedules', 'terms', 'settings']

function BottomTabBar({ currentPage, onNavigate, onSignOut }) {
  const [moreOpen, setMoreOpen] = useState(false)
  const sheetRef = useRef(null)

  useEffect(() => {
    if (!moreOpen) return
    function handleClick(e) {
      if (sheetRef.current && !sheetRef.current.contains(e.target)) {
        setMoreOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [moreOpen])

  const tabs = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      ),
    },
    {
      id: 'tasks',
      label: 'Tasks',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
        </svg>
      ),
    },
    {
      id: 'schedule',
      label: 'Classes',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      ),
    },
    {
      id: 'medication',
      label: 'Meds',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5A2.25 2.25 0 0 0 8.25 22.5h7.5A2.25 2.25 0 0 0 18 20.25V3.75A2.25 2.25 0 0 0 15.75 1.5H13.5" />
          <rect x="9" y="1" width="6" height="3" rx="1" />
          <line x1="12" y1="10" x2="12" y2="16" />
          <line x1="9" y1="13" x2="15" y2="13" />
        </svg>
      ),
    },
  ]

  const isMoreActive = MORE_PAGES.includes(currentPage)

  return (
    <nav className="bottom-tab-bar">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`bottom-tab ${currentPage === tab.id ? 'bottom-tab--active' : ''}`}
          onClick={() => onNavigate(tab.id)}
        >
          {tab.icon}
          <span className="bottom-tab-label">{tab.label}</span>
        </button>
      ))}
      <button
        className={`bottom-tab ${isMoreActive || moreOpen ? 'bottom-tab--active' : ''}`}
        onClick={() => setMoreOpen((v) => !v)}
        aria-label="More options"
        aria-expanded={moreOpen}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="5" r="1.5" />
          <circle cx="12" cy="12" r="1.5" />
          <circle cx="12" cy="19" r="1.5" />
        </svg>
        <span className="bottom-tab-label">More</span>
      </button>
      {moreOpen && (
        <div className="more-menu-overlay" onClick={() => setMoreOpen(false)}>
          <div className="more-menu-sheet" ref={sheetRef} onClick={(e) => e.stopPropagation()}>
            <button
              className={`more-menu-item ${currentPage === 'daily-schedules' ? 'more-menu-item--active' : ''}`}
              onClick={() => { onNavigate('daily-schedules'); setMoreOpen(false) }}
            >
              Daily Plans
            </button>
            <button
              className={`more-menu-item ${currentPage === 'terms' ? 'more-menu-item--active' : ''}`}
              onClick={() => { onNavigate('terms'); setMoreOpen(false) }}
            >
              Terms
            </button>
            <button
              className={`more-menu-item ${currentPage === 'settings' ? 'more-menu-item--active' : ''}`}
              onClick={() => { onNavigate('settings'); setMoreOpen(false) }}
            >
              Settings
            </button>
            {onSignOut && (
              <button
                className="more-menu-item more-menu-item--signout"
                onClick={() => { onSignOut(); setMoreOpen(false) }}
              >
                Sign Out
              </button>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

export default BottomTabBar
